export default "__VITE_ASSET__Bjk1F5ej__"